// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let SystemMessage = require("../../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function Form__Components$TextInputField(props) {
  let errorsFromForm = props.errorsFromForm;
  let validationResult = props.validationResult;
  let fieldStatus;
  let exit = 0;
  if (validationResult !== undefined && validationResult.TAG !== "Ok") {
    fieldStatus = "error";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    fieldStatus = errorsFromForm !== undefined ? "error" : (
        validationResult !== undefined && validationResult._0 === "Valid" ? "ok" : undefined
      );
  }
  let tmp;
  tmp = validationResult !== undefined && validationResult.TAG !== "Ok" ? JsxRuntime.jsx(FormV5.$$Error.make, {
      children: validationResult._0
    }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Form__Input.make, {
        labelText: props.labelText,
        type: props._type,
        autocomplete: props.autocomplete,
        autofocus: props.autofocus,
        optionalText: props.optionalText,
        placeholderText: props.placeholderText,
        onChange: props.onChange,
        onBlur: props.onBlur,
        disabled: props.disabled,
        onFocus: props.onFocus,
        status: fieldStatus,
        prepend: props.prepend,
        append: props.append,
        appendElement: props.appendElement,
        value: props.value,
        id: props.id,
        inputRef: props.inputRef
      }),
      tmp,
      errorsFromForm !== undefined ? JsxRuntime.jsx(FormV5.$$Error.make, {
          children: errorsFromForm
        }) : null
    ]
  });
}

let TextInputField = {
  make: Form__Components$TextInputField
};

function Form__Components$FieldError(props) {
  let valid = props.valid;
  if (valid === undefined) {
    return null;
  }
  if (typeof valid !== "object") {
    return null;
  }
  if (valid.NAME !== "Error") {
    return null;
  }
  let message = valid.VAL;
  if (message === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
      children: message
    });
  }
}

let FieldError = {
  make: Form__Components$FieldError
};

function Form__Components$FieldErrorV2(props) {
  let valid = props.valid;
  if (valid === undefined) {
    return null;
  }
  if (valid.TAG === "Ok") {
    return null;
  }
  let message = valid._0;
  if (message === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
      children: message
    });
  }
}

let FieldErrorV2 = {
  make: Form__Components$FieldErrorV2
};

function Form__Components$FieldErrorAsyncV2(props) {
  let __renderLoadingState = props.renderLoadingState;
  let valid = props.valid;
  let renderLoadingState = __renderLoadingState !== undefined ? __renderLoadingState : () => null;
  if (valid === undefined) {
    return null;
  }
  if (valid.TAG === "Validating") {
    return renderLoadingState();
  }
  let message = valid._0;
  if (message.TAG === "Ok") {
    return null;
  }
  let message$1 = message._0;
  if (message$1 === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
      children: message$1
    });
  }
}

let FieldErrorAsyncV2 = {
  make: Form__Components$FieldErrorAsyncV2
};

function Form__Components$FormStatusMessageV2(props) {
  let dismissSubmissionResult = props.dismissSubmissionResult;
  let resetForm = props.resetForm;
  let onSuccessMessage = props.onSuccessMessage;
  let status = props.status;
  if (typeof status !== "object") {
    if (status === "Editing" || onSuccessMessage === undefined) {
      return null;
    } else {
      return JsxRuntime.jsx(SystemMessage.make, {
        id: "form_submitted",
        time: 5000,
        text: onSuccessMessage,
        type_: "success",
        dismissible: true,
        secondary: true,
        handleOnDismiss: _id => resetForm()
      });
    }
  }
  if (status.TAG === "Submitting") {
    return null;
  }
  let serverMessage = props.submissionErrorToString(status._0);
  if (serverMessage !== undefined) {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "form_submitted",
      time: 5000,
      text: serverMessage,
      type_: "error",
      dismissible: true,
      secondary: true,
      handleOnDismiss: _id => dismissSubmissionResult()
    });
  } else {
    return null;
  }
}

let FormStatusMessageV2 = {
  make: Form__Components$FormStatusMessageV2
};

let View;

let $$Error;

let MediaQuery;

exports.View = View;
exports.$$Error = $$Error;
exports.MediaQuery = MediaQuery;
exports.TextInputField = TextInputField;
exports.FieldError = FieldError;
exports.FieldErrorV2 = FieldErrorV2;
exports.FieldErrorAsyncV2 = FieldErrorAsyncV2;
exports.FormStatusMessageV2 = FormStatusMessageV2;
/* FormV5 Not a pure module */
